export default __webpack_public_path__ + "static/media/tick.17b1d4f8.svg";